<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M5.83323 18.3332V9.1665M1.66656 10.8332V16.6665C1.66656 17.587 2.41276 18.3332 3.33323 18.3332H14.5218C15.7557 18.3332 16.8051 17.4329 16.9927 16.2133L17.8901 10.38C18.1231 8.86558 16.9514 7.49984 15.4192 7.49984H12.4999C12.0397 7.49984 11.6666 7.12674 11.6666 6.6665V3.72137C11.6666 2.5865 10.7466 1.6665 9.6117 1.6665C9.34101 1.6665 9.09571 1.82592 8.98578 2.07327L6.05318 8.67162C5.91943 8.97256 5.62099 9.1665 5.29167 9.1665H3.33323C2.41276 9.1665 1.66656 9.9127 1.66656 10.8332Z"
      stroke="currentColor"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
